export default __webpack_public_path__ + "static/media/delivery.5f4ba680.svg";